import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import moment from 'moment';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';


const Depreciationoptions = [
    { label: "Straight Line Method (SLM)", value: 1 },
    { label: "Written Down Value (WDV)", value: 2 },
    { label: "Double Declining Balance (DDB)", value: 3 },
    { label: "Units of Production (UOP)", value: 4 },
    { label: "Sum of Years' Digits (SYD)", value: 5 }
];
class AddAssetMaster extends Component {
    state = {
        type: 'add',
        // Id: null,
        AssetId: null,
        AssetNumber: '',
        AssetName: '',
        SerialNumber: '',
        // CompanyId: null,
        CompanyId: this.props.loggedUserDetail?.CompanyId || Companyid,
        ResponsibleDepartment: null,
        Location: '',
        StartDate: null,
        EmployeeId: null,
        CategoryId: null,
        Remarks: '',
        IsActive: false,
        DepreciationApplicable: false,
        DepreciationMethod: null,
        WarrantyStartDate: null,
        WarrantyEndDate: null,
        AMCStartDate: null,
        AMCEndDate: null,
        ServiceVendor: null,
        AssetStatus:null,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        touch: false,
        dataFetched: false  // ADD THIS



    }

    // componentDidMount() {
    //     const type = this.props.match.params.type;
    //     const id = this.props.match.params.id;
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);

    //     // this.props.getMasterKeywordList("Asset");
    //     this.props.getMasterKeywordList("employee");
    //     this.props.getMasterKeywordList("orgunit");
    //     this.props.getMasterKeywordList("vendor");
    //     this.props.getMasterKeywordList("AssetCategory");

    //     this.props.getMasterTableList('res/GetAssetbyid?AssetId=' + id, this.props.loggedUserDetail.CompanyId);

    //     this.setState({
    //         type,
    //         dataFetched: false
    //     });

    //     // if (type !== "add") {
    //     // this.fetchSingleProcess(id);
    //     if (type !== "add" && id && id !== 'null' && id !== 'undefined') {
    //         this.props.getMasterTableList('res/GetAssetbyid?AssetId=' + id, this.props.loggedUserDetail.CompanyId);
    //     }

    // }

    // fetchSingleProcess = (id) => {

    //     this.props.getMasterTableList(
    //         'res/GetAssetbyid?AssetId='+id,
    //         this.props.loggedUserDetail.CompanyId
    //     );

    // }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);

    //     const type = this.props.match.params.type;
    //     const id = this.props.match.params.id;

    //     this.setState({ type });

    //     this.props.getMasterKeywordList("employee");
    //     this.props.getMasterKeywordList("orgunit");
    //     this.props.getMasterKeywordList("vendor");
    //     this.props.getMasterKeywordList("AssetCategory");

    //     if (type !== "add" && id && id !== 'null' && id !== 'undefined') {
    //         this.props.getMasterTableList(`res/GetAssetbyid?AssetId=${id}`, this.props.loggedUserDetail?.CompanyId || Companyid);
    //     }
    // }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        const { type, id } = this.props.match.params;

        this.setState({
            type,
            dataFetched: false
        });

        this.props.getMasterKeywordList("Employee");
        this.props.getMasterKeywordList("orgunit");
        this.props.getMasterKeywordList("vendor");
        this.props.getMasterKeywordList("AssetCategory");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetAssetbyid?AssetId=${id}`,
                this.state.CompanyId
            );
        }
    }


    // componentDidUpdate(prevProps) {

    //     if (
    //         this.props.tableLists &&
    //         this.props.tableLists !== prevProps.tableLists &&
    //         !this.state.dataFetched
    //     ) {


    //         const asset = this.props.tableLists;
    //         const type = this.props.match.params.type;
    //         if (asset && typeof asset === 'object' && !Array.isArray(asset)) {

    //             this.setState({

    //                 Id: asset.id,
    //                 AssetNumber: asset.assetCode,
    //                 AssetName: asset.assetName,
    //                 SerialNumber: asset.serialNumber,
    //                 CompanyId: asset.companyid,
    //                 ResponsibleDepartment: asset.department,
    //                 Location: asset.currentLocation,
    //                 StartDate: asset.purchaseDate ? new Date(asset.purchaseDate) : null,
    //                 EmployeeId: asset.EmployeeId,
    //                 CategoryId: asset.assetCategory,
    //                 Remarks: asset.remark,
    //                 IsActive: asset.isActive,
    //                 DepreciationApplicable: asset.depreciationApplicable,
    //                 DepreciationMethod: asset.depreciationMethod,
    //                 WarrantyStartDate: asset.warrantyStartDate ? new Date(asset.warrantyStartDate) : null,
    //                 WarrantyEndDate: asset.warrantyEndDate ? new Date(asset.warrantyEndDate) : null,
    //                 AMCStartDate: asset.amcstartDate ? new Date(asset.amcstartDate) : null,
    //                 AMCEndDate: asset.amcendDate ? new Date(asset.amcendDate) : null,
    //                 ServiceVendor: asset.serviceVendor,
    //                 dataFetched: true
    //             });

    //         }
    //     }

    // }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }

    // componentDidUpdate(prevProps) {

    //     if (
    //         this.props.tableLists &&
    //         this.props.tableLists !== prevProps.tableLists &&
    //         !this.state.dataFetched
    //     ) {

    //         const asset = this.props.tableLists;

    //         this.setState({

    //             Id: asset.assetId,
    //             AssetNumber: asset.assetCode,
    //             AssetName: asset.assetName,
    //             SerialNumber: asset.serialNumber,

    //             CompanyId: asset.companyid,

    //             ResponsibleDepartment: asset.department,

    //             Location: asset.currentLocation,

    //             StartDate: asset.purchaseDate
    //                 ? new Date(asset.purchaseDate)
    //                 : null,

    //             EmployeeId: asset.employeeId,

    //             CategoryId: asset.assetCategory,

    //             Remarks: asset.remark,

    //             IsActive: asset.isActive,

    //             DepreciationApplicable: asset.depreciationApplicable,

    //             DepreciationMethod: asset.depreciationMethod,

    //             WarrantyStartDate: asset.warrantyStartDate
    //                 ? new Date(asset.warrantyStartDate)
    //                 : null,

    //             WarrantyEndDate: asset.warrantyEndDate
    //                 ? new Date(asset.warrantyEndDate)
    //                 : null,

    //             AMCStartDate: asset.amcstartDate
    //                 ? new Date(asset.amcstartDate)
    //                 : null,

    //             AMCEndDate: asset.amcendDate
    //                 ? new Date(asset.amcendDate)
    //                 : null,

    //             ServiceVendor: asset.serviceVendor,

    //             dataFetched: true

    //         });

    //     }

    // }

    componentDidUpdate(prevProps) {
        if (
            this.props.tableLists !== prevProps.tableLists &&
            this.props.tableLists
        ) {

            console.log("Asset Response :", this.props.tableLists);

            const asset = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!asset) return;

            this.setState({
                AssetId: asset.assetId,
                AssetNumber: asset.assetCode || "",
                AssetName: asset.assetName || "",
                SerialNumber: asset.serialNumber || "",
                CompanyId: asset.companyid,
                ResponsibleDepartment: asset.department,
                Location: asset.currentLocation || "",
                StartDate: asset.purchaseDate ? new Date(asset.purchaseDate) : null,
                EmployeeId: this.matchDropdownValue(this.props.GetEmployeedropdown, asset.employeeId),
                CategoryId: (asset.assetCategory !== null && asset.assetCategory !== undefined) ? String(asset.assetCategory) : null,
                Remarks: asset.remark || "",
                IsActive: asset.isActive,
                DepreciationApplicable: asset.depreciationApplicable,
                DepreciationMethod: asset.depreciationMethod,
                WarrantyStartDate: asset.warrantyStartDate ? new Date(asset.warrantyStartDate) : null,
                WarrantyEndDate: asset.warrantyEndDate ? new Date(asset.warrantyEndDate) : null,
                AMCStartDate: asset.amcstartDate ? new Date(asset.amcstartDate) : null,
                AMCEndDate: asset.amcendDate ? new Date(asset.amcendDate) : null,
                ServiceVendor: asset.serviceVendor,
                dataFetched: true,
                AssetStatus: asset.assetStatus,
                createdDate: asset.createdDate || new Date(),

            });
        }
    }

    componentWillUnmount() {
        if (this.props.tableLists.assetsList !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    // Matches a raw id from the API against a keyword dropdown's options
    // (dropdown option values are always strings) and returns the option's
    // own value, so the Dropdown's selected value type always lines up.
    matchDropdownValue = (options, rawId) => {
        if (rawId === null || rawId === undefined || rawId === '') {
            return null;
        }
        const match = Array.isArray(options)
            ? options.find(el => el.value == rawId)
            : undefined;
        return match ? match.value : String(rawId);
    }

    // fetchSingleProcess = () => {
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists !== undefined) {
    //         storageItems = this.props.tableLists;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 AssetNumber: filterData.assetNumber,
    //                 SerialNumber: filterData.serialNumber,
    //                 CompanyId: filterData.companyId,
    //                 ResponsibleDepartment: filterData.responsibleDepartment,
    //                 DateAcquired: filterData.dateAcquired ? new Date(filterData.dateAcquired) : null,
    //                 Location: filterData.location,
    //                 StartDate: filterData.startDate ? new Date(filterData.startDate) : null,
    //                 IsActive: filterData.isActive,
    //                 Remarks: filterData.remarks,
    //                 EmployeeId: filterData.employeeId,
    //                 CurrentItemQty: filterData.currentItemQty,
    //                 OriginalQty: filterData.originalQty,
    //                 DefaultUnitOfMeasure: filterData.defaultUnitOfMeasure,
    //                 InventoryItemNo: filterData.inventoryItemNo,
    //             }
    //             this.setState(data);
    //         }
    //     }
    // }

    // Handle dropdown change
    onDropdownChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })
    // }

    change = (e) => {
        let { name, value, checked, type } = e.target;

        // Handle different input types
        if (type === 'checkbox' || type === 'switch') {
            this.setState({ [name]: checked, touch: true });
        } else {
            this.setState({ [name]: value, touch: true });
        }
    }

    // Handle checkbox change
    handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked, touch: true });
    }

    // Handle calendar change
    handleDateChange = (name, value) => {
        this.setState({ [name]: value, touch: true });
    }

    add = () => {
        if (this.state.AssetNumber === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Asset Number is required' });
            return;
        } else if (this.state.AssetName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Asset Name is required' });
            return;
        } else if (this.state.SerialNumber === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Serial Number is required' });
            return;
        } else if (this.state.ResponsibleDepartment === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Responsible Department is required' });
            return;
        } else if (this.state.Location === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Location is required' });
            return;
        } else if (this.state.StartDate === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Start Date is required' });
            return;
        } else if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.CategoryId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Category is required' });
            return;
        }

        var data = {
            assetId: this.state.AssetId,
            assetCode: this.state.AssetNumber,
            assetName: this.state.AssetName,
            serialNumber: this.state.SerialNumber,
            companyid: this.state.CompanyId,
            department: this.state.ResponsibleDepartment,
            currentLocation: this.state.Location,
            purchaseDate: this.state.StartDate ? moment(this.state.StartDate).format('MM/DD/YYYY') : null,
            EmployeeId: this.state.EmployeeId,
            assetCategory: this.state.CategoryId,
            remark: this.state.Remarks,
            isActive: this.state.IsActive,


            depreciationApplicable: this.state.DepreciationApplicable,
            depreciationMethod: this.state.DepreciationMethod,
            warrantyStartDate: this.state.WarrantyStartDate ? moment(this.state.WarrantyStartDate).format('MM/DD/YYYY') : null,
            warrantyEndDate: this.state.WarrantyEndDate ? moment(this.state.WarrantyEndDate).format('MM/DD/YYYY') : null,
            amcstartDate: this.state.AMCStartDate ? moment(this.state.AMCStartDate).format('MM/DD/YYYY') : null,
            amcendDate: this.state.AMCEndDate ? moment(this.state.AMCEndDate).format('MM/DD/YYYY') : null,
            serviceVendor: this.state.ServiceVendor,
            assetStatus:this.state.AssetStatus,
            createdDate: this.state.createdDate,
        }

        if (this.state.type === 'edit') {
            data.AssetId = this.state.AssetId
        }

        this.props.processDynamicData('Asset', this.state.type, data, 'res/GetAssetbyid?' + Companyid);
    }

    resetData = () => {
        var data = {
            type: 'add',
            AssetId: null,
            AssetNumber: '',
            AssetName: '',
            SerialNumber: '',
            CompanyId: this.props.loggedUserDetail?.CompanyId || Companyid,
            ResponsibleDepartment: null,
            Location: '',
            StartDate: null,
            EmployeeId: null,
            CategoryId: null,
            Remarks: '',
            IsActive: false,
            DepreciationApplicable: false,
            DepreciationMethod: null,
            WarrantyStartDate: null,
            WarrantyEndDate: null,
            AMCStartDate: null,
            AMCEndDate: null,
            ServiceVendor: null,
            touch: false,

        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/Asset/', this.props);


        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let companyOptions = [];
        if (this.props.Company && this.props.Company.length > 0) {
            companyOptions = this.props.Company;
        }
        let departmentOptions = [];
        if (this.props.Department && this.props.Department.length > 0) {
            departmentOptions = this.props.Department;
        }
        let uomOptions = [];
        if (this.props.UnitOfMeasure && this.props.UnitOfMeasure.length > 0) {
            uomOptions = this.props.UnitOfMeasure;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/asset/';

        // Add this line - define isViewMode
        // const isViewMode = this.state.type === 'view';


        // return (
        //     <div className="p-grid">
        //         {this.props.loading && <div className="page-loader"></div>}
        //         {this.props.error !== null && <Messages type="error" message={this.props.error} />}
        //         {this.props.success !== null && <Messages type="success" message={this.props.success} />}
        //         <Toast ref={(el) => this.growl = el} />
        //         <div className="p-col-12">
        //             <div className="card card-w-title" style={{ position: 'relative' }}>
        //                 <h1>{this.state.type} Asset</h1>

        //                 <div className="p-grid mt1">


        //                     <div className="p-col-12">
        //                         <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px' }}>Asset Information</h3>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Asset Number <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputText className="p-col-12" name="AssetNumber" placeholder="Asset Number" value={this.state.AssetNumber} onChange={this.change} disabled={isViewMode} // Disable in view mode
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Asset Name <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputText className="p-col-12" name="AssetName" placeholder="Asset Name" value={this.state.AssetName} onChange={this.change} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Serial Number <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputText className="p-col-12" name="SerialNumber" placeholder="Serial Number" value={this.state.SerialNumber} onChange={this.change} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>


        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Responsible Department <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Dropdown className="p-col-12" placeholder="Select Department" options={this.props.orgunit} value={this.state.ResponsibleDepartment} name="ResponsibleDepartment" onChange={this.change} {...DROPDOWN_CONFIG} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>



        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Location <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputText className="p-col-12" name="Location" placeholder="Location" value={this.state.Location} onChange={this.change} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Start Date <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Calendar className="width100" name="StartDate" placeholder="Start Date" value={this.state.StartDate} onChange={(e) => this.setState({ StartDate: e.value, touch: true })} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>
        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Employee <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Dropdown className="p-col-12" placeholder="Select Employee" options={this.props.employee} value={this.state.EmployeeId} name="EmployeeId" onChange={this.change} {...DROPDOWN_CONFIG} disabled={isViewMode}
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Category <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Dropdown className="p-col-12" placeholder="Select Category" options={this.props.AssetCategory} value={this.state.CategoryId} name="CategoryId" onChange={this.change} {...DROPDOWN_CONFIG} />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Remarks <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputText className="p-col-12" name="Remarks" placeholder="Remarks" value={this.state.Remarks} onChange={this.change} />
        //                         </div>
        //                     </div>
        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Status :</label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <InputSwitch checked={this.state.IsActive} value={this.state.IsActive} onChange={this.change} name="IsActive" />
        //                         </div>
        //                     </div>


        //                     <div className="p-col-12">
        //                         <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px' }}>Key Information</h3>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Depreciation Applicable <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Checkbox
        //                                 inputId="DepreciationApplicable"
        //                                 checked={this.state.DepreciationApplicable}
        //                                 onChange={(e) =>
        //                                     this.setState({
        //                                         DepreciationApplicable: e.checked,
        //                                         touch: true
        //                                     })
        //                                 }
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Depreciation Mehtod <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Dropdown
        //                                 className="p-col-12"
        //                                 placeholder="Select Method"
        //                                 options={Depreciationoptions}
        //                                 value={this.state.DepreciationMethod}
        //                                 name="DepreciationMethod"
        //                                 onChange={this.change}
        //                                 {...DROPDOWN_CONFIG}
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label>Warranty Start Date</label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Calendar
        //                                 className="width100"
        //                                 placeholder="Warranty Start Date"
        //                                 value={this.state.WarrantyStartDate}
        //                                 onChange={(e) =>
        //                                     this.setState({
        //                                         WarrantyStartDate: e.value,
        //                                         touch: true
        //                                     })
        //                                 }
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Warranty End Date <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Calendar
        //                                 className="width100"
        //                                 placeholder="Warranty End Date"
        //                                 value={this.state.WarrantyEndDate}
        //                                 onChange={(e) =>
        //                                     this.setState({
        //                                         WarrantyEndDate: e.value,
        //                                         touch: true
        //                                     })
        //                                 }
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">AMC Start Date <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Calendar
        //                                 className="width100"
        //                                 placeholder="AMC Start Date"
        //                                 value={this.state.AMCStartDate}
        //                                 onChange={(e) =>
        //                                     this.setState({
        //                                         AMCStartDate: e.value,
        //                                         touch: true
        //                                     })
        //                                 }
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">AMC End Date <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Calendar
        //                                 className="width100"
        //                                 placeholder="AMC End Date"
        //                                 value={this.state.AMCEndDate}
        //                                 onChange={(e) =>
        //                                     this.setState({
        //                                         AMCEndDate: e.value,
        //                                         touch: true
        //                                     })
        //                                 }
        //                             />
        //                         </div>
        //                     </div>

        //                     <div className="p-col-4">
        //                         <div className="p-col-12">
        //                             <label htmlFor="acSimple">Service Vendor <span className="requiredColor">*</span></label>
        //                         </div>
        //                         <div className="p-col-12">
        //                             <Dropdown
        //                                 className="p-col-12"
        //                                 placeholder="Select Service Vendor"
        //                                 options={this.props.vendor}
        //                                 value={this.state.ServiceVendor}
        //                                 name="ServiceVendor"
        //                                 onChange={this.change}
        //                                 {...DROPDOWN_CONFIG}
        //                             />
        //                         </div>
        //                     </div>



        //                     <div className="p-col-12 p-lg-12">
        //                         <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} />
        //                     </div>

        //                 </div>

        //             </div>
        //         </div>
        //     </div>
        // );

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type === 'edit' ? 'Edit' : this.state.type === 'view' ? 'View' : 'Add'} Asset</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px' }}>Asset Information</h3>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Asset Number <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="AssetNumber"
                                        placeholder="Asset Number"
                                        value={this.state.AssetNumber}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'} // Disable in view mode
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Asset Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="AssetName"
                                        placeholder="Asset Name"
                                        value={this.state.AssetName}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Serial Number <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="SerialNumber"
                                        placeholder="Serial Number"
                                        value={this.state.SerialNumber}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Responsible Department <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Department"
                                        options={this.props.orgunit}
                                        value={this.state.ResponsibleDepartment}
                                        name="ResponsibleDepartment"
                                        onChange={this.onDropdownChange}                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Location <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="Location"
                                        placeholder="Location"
                                        value={this.state.Location}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Start Date <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Calendar
                                        className="width100"
                                        name="StartDate"
                                        placeholder="Start Date"
                                        value={this.state.StartDate}
                                        onChange={(e) => this.handleDateChange('StartDate', e.value)}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Employee <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Employee"
                                        options={this.props.GetEmployeedropdown}
                                        value={this.state.EmployeeId}
                                        name="EmployeeId"
                                        onChange={this.onDropdownChange}                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Category <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Category"
                                        options={this.props.AssetCategory}
                                        value={this.state.CategoryId}
                                        name="CategoryId"
                                        onChange={this.onDropdownChange}                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Remarks</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="Remarks"
                                        placeholder="Remarks"
                                        value={this.state.Remarks}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch
                                        checked={this.state.IsActive}
                                        value={this.state.IsActive}
                                        onChange={this.change}
                                        name="IsActive"
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-12">
                                <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px' }}>Key Information</h3>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Depreciation Applicable</label>
                                </div>
                                <div className="p-col-12">
                                    <Checkbox
                                        inputId="DepreciationApplicable"
                                        name="DepreciationApplicable"
                                        checked={this.state.DepreciationApplicable}
                                        onChange={this.handleCheckboxChange}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Depreciation Method</label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Method"
                                        options={Depreciationoptions}
                                        value={this.state.DepreciationMethod}
                                        name="DepreciationMethod"
                                        onChange={this.onDropdownChange}
                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label>Warranty Start Date</label>
                                </div>
                                <div className="p-col-12">
                                    <Calendar
                                        className="width100"
                                        placeholder="Warranty Start Date"
                                        value={this.state.WarrantyStartDate}
                                        onChange={(e) => this.handleDateChange('WarrantyStartDate', e.value)}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Warranty End Date</label>
                                </div>
                                <div className="p-col-12">
                                    <Calendar
                                        className="width100"
                                        placeholder="Warranty End Date"
                                        value={this.state.WarrantyEndDate}
                                        onChange={(e) => this.handleDateChange('WarrantyEndDate', e.value)}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">AMC Start Date</label>
                                </div>
                                <div className="p-col-12">
                                    <Calendar
                                        className="width100"
                                        placeholder="AMC Start Date"
                                        value={this.state.AMCStartDate}
                                        onChange={(e) => this.handleDateChange('AMCStartDate', e.value)}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">AMC End Date</label>
                                </div>
                                <div className="p-col-12">
                                    <Calendar
                                        className="width100"
                                        placeholder="AMC End Date"
                                        value={this.state.AMCEndDate}
                                        onChange={(e) => this.handleDateChange('AMCEndDate', e.value)}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Service Vendor</label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Service Vendor"
                                        options={this.props.vendor}
                                        value={this.state.ServiceVendor}
                                        name="ServiceVendor"
                                        // onChange={this.change}
                                        onChange={this.onDropdownChange}
                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === 'view'}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to={redirectURL}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        Company: (state.keyword.Company !== undefined) ? state.keyword.Company : [],
        Department: (state.keyword.Department !== undefined) ? state.keyword.Department : [],
        UnitOfMeasure: (state.keyword.UnitOfMeasure !== undefined) ? state.keyword.UnitOfMeasure : [],
        employee: (state.keyword.employee !== undefined) ? state.keyword.employee : [],
        orgunit: (state.keyword.orgunit !== undefined) ? state.keyword.orgunit : [],
        vendor: (state.keyword.vendor !== undefined) ? state.keyword.vendor : [],
        AssetCategory: (state.keyword.AssetCategory !== undefined) ? state.keyword.AssetCategory : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAssetMaster);